import React, { useMemo } from "react";
import { FundDataBasic } from "../../interfaces/DTO/FundDataBasic";

import SearchAutocomplete from "../UIParts/SearchAutocomplete";
import { fundService } from "../../services/fundService";
import { formatProductType } from "../../utils/enumFormatter";
import { formatHandlerCode } from "../../utils/namesFormater";

interface Props {
  value: string;
  onChange: (newValue: string) => void;
  onSelect: (fund: FundDataBasic) => void;
  handlerFilter?: string[];
  productTypeFilter?: number[];
  placeholder?: string;
}

export const SearchFundAutocomplete: React.FC<Props> = ({
  value,
  onChange,
  onSelect,
  handlerFilter,
  productTypeFilter,
  placeholder = "חפש קרן...",
}) => {
const filteredFunds = useMemo(() => {
  const results: FundDataBasic[] = [];

  // 🔹 אם יש גם productType וגם handler
  if (productTypeFilter?.length && handlerFilter?.length) {
    for (const productType of productTypeFilter) {
      for (const handler of handlerFilter) {
        results.push(
          ...fundService.getFundsFromCacheByCriteria({
            productType,
            handler_code: handler,
          })
        );
      }
    }
  }
  // 🔹 רק productType
  else if (productTypeFilter?.length) {
    for (const productType of productTypeFilter) {
      results.push(
        ...fundService.getFundsFromCacheByCriteria({ productType })
      );
    }
  }
  // 🔹 רק handler
  else if (handlerFilter?.length) {
    for (const handler of handlerFilter) {
      results.push(
        ...fundService.getFundsFromCacheByCriteria({ handler_code: handler })
      );
    }
  }

  // הסרת כפילויות לפי fund_id
  const uniqueFunds = new Map<number, FundDataBasic>();
  results.forEach((fund) => {
    if (!uniqueFunds.has(fund.fund_id)) {
      uniqueFunds.set(fund.fund_id, fund);
    }
  });

  return Array.from(uniqueFunds.values());
}, [handlerFilter, productTypeFilter]);


  const dynamicPlaceholder = useMemo(() => {
    const parts: string[] = [];

    if (productTypeFilter?.length) {
      const names = productTypeFilter.map(formatProductType).join(", ");
      parts.push(names);
    }

    if (handlerFilter?.length) {
      const handlers = handlerFilter.map(formatHandlerCode).join(", ");
      parts.push(`של ${handlers}`);
    }

    return `חפש קרן${parts.length ? ` (${parts.join(" ")})` : ""}...`;
  }, [productTypeFilter, handlerFilter]);

  const options = useMemo(
    () =>
      filteredFunds.map((fund) => ({
        label: `${fund.fund_name} (${fund.fund_id})`,
        fund,
      })),
    [filteredFunds]
  );

  const handleSelect = (selectedLabel: string) => {
    onChange(selectedLabel);
    const selected = options.find((opt) => opt.label === selectedLabel);
    if (selected) {
      onSelect(selected.fund);
    }
  };



  return (
    <SearchAutocomplete
      placeholder={dynamicPlaceholder || placeholder}
      options={options.map((opt) => opt.label)}
      value={value}
      onChange={handleSelect}
    />
  );
};
